document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.popular_search_main').forEach(function(wrapper) {
    const container = wrapper?.querySelector(".popular_search_content");
    if (!wrapper || !container) return;

    // Read settings from data attributes
    const speed = parseFloat(wrapper.dataset.speed) || 50; // pixels per second
    const direction = wrapper.dataset.direction || "left";
    const pauseOnHover = wrapper.dataset.pause === "true";

    let running = true;
    let lastTime = performance.now();
    let translate = 0;

    // 🔹 1. Ensure enough cards (clone until total width > 2× wrapper width)
    const wrapperWidth = wrapper.offsetWidth;
    while (container.scrollWidth < wrapperWidth * 2) {
      container.innerHTML += container.innerHTML;
    }

    function step(now) {
      if (!running) {
        requestAnimationFrame(step);
        return;
      }

      const elapsed = (now - lastTime) / 1000;
      lastTime = now;
      const distance = speed * elapsed;

      if (direction === "left") {
        translate -= distance;
        const firstCard = container.firstElementChild;
        if (firstCard) {
          const cardWidth = firstCard.offsetWidth + parseInt(getComputedStyle(container).columnGap || 0);
          if (Math.abs(translate) >= cardWidth) {
            translate += cardWidth;
            container.appendChild(firstCard);
          }
        }
        container.style.transform = `translateX(${translate}px)`;
      }

      else if (direction === "right") {
        translate += distance;
        const lastCard = container.lastElementChild;
        if (lastCard) {
          const cardWidth = lastCard.offsetWidth + parseInt(getComputedStyle(container).columnGap || 0);
          if (translate >= cardWidth) {
            translate -= cardWidth;
            container.prepend(lastCard);
          }
        }
        container.style.transform = `translateX(${translate}px)`;
      }

      requestAnimationFrame(step);
    }

    requestAnimationFrame(step);

    // Pause on hover → container only
    if (pauseOnHover) {
      container.addEventListener("mouseenter", () => { running = false; });
      container.addEventListener("mouseleave", () => { 
        lastTime = performance.now();
        running = true;
      });
    }
  });
});






// const container = wrapper?.querySelector(".popular_search_content");
    // if (!wrapper || !container) return;

    // // Read settings from data attributes
    // const speed = parseInt(wrapper.dataset.speed, 10) || 20;
    // const direction = wrapper.dataset.direction || "left";
    // const pauseOnHover = wrapper.dataset.pause === "true";

    // // Clone cards for infinite scroll
    // const cards = container.innerHTML;
    // container.innerHTML += cards + cards;

    // let animation;

    // if (direction === "left" || direction === "right") {
    //     const totalWidth = container.scrollWidth / 2;
    //     container.style.width = totalWidth * 2 + "px";

    //     animation = container.animate(
    //     [
    //         { transform: direction === "left" ? "translateX(0)" : `translateX(-${totalWidth}px)` },
    //         { transform: direction === "left" ? `translateX(-${totalWidth}px)` : "translateX(0)" }
    //     ],
    //     { duration: speed * 1000, iterations: Infinity, easing: "linear" }
    //     );
    // } else {
    //     const totalHeight = container.scrollHeight / 2;
    //     container.style.flexDirection = "column";

    //     animation = container.animate(
    //     [
    //         { transform: direction === "up" ? "translateY(0)" : `translateY(-${totalHeight}px)` },
    //         { transform: direction === "up" ? `translateY(-${totalHeight}px)` : "translateY(0)" }
    //     ],
    //     { duration: speed * 1000, iterations: Infinity, easing: "linear" }
    //     );
    // }

    // // Pause on hover → container only
    // if (pauseOnHover) {
    //     container.addEventListener("mouseenter", () => animation.pause());
    //     container.addEventListener("mouseleave", () => animation.play());
    // }